<template>
  <div>
    <button class="uk-button uk-button-default uk-margin-bottom" type="button" @click="toggled = !toggled">
      <Icon :name="iconName"></Icon>
      {{ buttonName }}
    </button>
    <div v-show="!toggled">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon';

/**
 * A component that encapsulates another component and
 * makes it toggle via a button
 */
export default {
  name: 'collapsible',
  components: { Icon },
  props: {
    buttonName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      toggled: false,
    };
  },
  computed: {
    iconName() {
      return this.toggled ? 'chevron-down' : 'chevron-up';
    },
  },
};
</script>



// WEBPACK FOOTER //
// Collapsible.vue?47a4dc04